import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group alignC" }
const _hoisted_3 = { class: "flex alignC mar-r-18" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "到期时间", -1)
const _hoisted_5 = { class: "flex alignC" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "提醒类别", -1)
const _hoisted_7 = { class: "flex alignC" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, " 导出 ", -1)
const _hoisted_9 = { class: "flex flexC" }
const _hoisted_10 = {
  key: 0,
  class: "view-cirle"
}
const _hoisted_11 = { style: {"white-space":"pre-wrap"} }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { style: {"color":"#409EFF"} }
const _hoisted_14 = { style: {"color":"#999","margin-left":"10px"} }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  class: "flex flexC button-group",
  style: {"justify-content":"center"}
}
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "报价", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "跟进", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "出单", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "战败", -1)
const _hoisted_21 = { class: "flex flexR mar-t-22" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { class: "flex-1" }
const _hoisted_24 = { class: "flex-1" }
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_28 = { class: "dialog-footer" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "确认", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_31 = { class: "dialog-footer" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "确认", -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_34 = { class: "dialog-footer" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "确认", -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode("取 消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.screenParameter.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.date = $event)),
          type: "daterange",
          align: "right",
          "unlink-panels": "",
          "range-separator": "-",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          shortcuts: _ctx.shortcuts,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenChange($event, 'start_date')))
        }, null, 8, ["modelValue", "shortcuts"])
      ]),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_select, {
          class: "mar-r-16",
          style: {"width":"150px"},
          modelValue: _ctx.screenParameter.status,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenParameter.status = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _ctx.screenChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "保养到期",
              value: "1"
            }),
            _createVNode(_component_el_option, {
              label: "年检到期",
              value: "2"
            }),
            _createVNode(_component_el_option, {
              label: "商业险到期",
              value: "3"
            }),
            _createVNode(_component_el_option, {
              label: "交强险到期",
              value: "4"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.screenParameter.search,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenParameter.search = $event)),
          placeholder: "车牌号码/车架号",
          class: "mar-l-16 mar-r-18",
          "suffix-icon": "el-icon-search",
          onChange: _ctx.screenChange
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx.exportChange
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "车牌号码",
          align: "center",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", null, _toDisplayString(scope.row.code), 1),
              (scope.row.is_manual == 1)
                ? (_openBlock(), _createBlock("div", _hoisted_10, " B "))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "到期类别",
          align: "center",
          "min-width": "164"
        }, {
          default: _withCtx((scope) => [
            _createVNode("view", _hoisted_11, _toDisplayString(scope.row.text), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "跟进次数",
          align: "center",
          "min-width": "80"
        }, {
          default: _withCtx((scope) => [
            _createVNode("span", null, _toDisplayString(scope.row.deal_num || 0), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "跟进记录",
          align: "center",
          "min-width": "300"
        }, {
          default: _withCtx((scope) => [
            (scope.row.deal_json && scope.row.deal_json.length)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row.deal_json, (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      style: {"text-align":"left","margin-bottom":"5px"}
                    }, [
                      _createVNode("span", _hoisted_13, _toDisplayString(item.admin_name) + ":", 1),
                      _createVNode("span", null, _toDisplayString(item.remark), 1),
                      _createVNode("span", _hoisted_14, _toDisplayString(item.deal_time), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_15, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "164"
        }, {
          default: _withCtx((scope) => [
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_el_button, {
                class: "border-red",
                onClick: ($event: any) => (_ctx.openQuoteDialog(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                class: "border-red",
                onClick: ($event: any) => (_ctx.openFollowDialog(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                class: "border-red",
                onClick: ($event: any) => (_ctx.openIssueDialog(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                class: "border-red",
                onClick: ($event: any) => (_ctx.openDefeatDialog(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_21, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20, 50, 100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "出单",
      modelValue: _ctx.issueForm.dialog_show,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.issueForm.dialog_show = $event)),
      center: "",
      width: 1000
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_25, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.issueSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.issueForm.dialog_show = false))
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.issueForm,
          "label-width": "160px"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_el_form_item, { label: "出单日期" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      value: _ctx.issueForm.today,
                      disabled: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "保险到期日期" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.expire_date,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.issueForm.expire_date = $event)),
                      placeholder: "请选择保险到期日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "车牌" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.car_code,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.issueForm.car_code = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "品牌" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.brand,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.issueForm.brand = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "车架号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.vin,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.issueForm.vin = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "联系方式" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.phone,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.issueForm.phone = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "保险公司" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.insurance_company,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.issueForm.insurance_company = $event)),
                      placeholder: "请选择",
                      clearable: "",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.issueForm.insurance_data, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.name,
                            value: item.id,
                            key: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "提供人" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.provider,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.issueForm.provider = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "出单员" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.issuer,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.issueForm.issuer = $event)),
                      placeholder: "请选择",
                      clearable: "",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.issueForm.staff_data, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.username,
                            value: item.name,
                            key: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "转续" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.renewal,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.issueForm.renewal = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "三者" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.third_party,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.issueForm.third_party = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "商业险金额" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.commercial_amount,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.issueForm.commercial_amount = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "商业保险" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.commercial_insurance,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.issueForm.commercial_insurance = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "交强险金额" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.ci_amount,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.issueForm.ci_amount = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_24, [
                _createVNode(_component_el_form_item, { label: "交强险返点率" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.ci_rebate_rate,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.issueForm.ci_rebate_rate = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "车船税" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.vehicle_tax,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.issueForm.vehicle_tax = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "意外险" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.accident_insurance,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.issueForm.accident_insurance = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "意外险A" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.accident_insurance_a,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.issueForm.accident_insurance_a = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "保险提成" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.insurance_commission,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.issueForm.insurance_commission = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "总保险合计" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.total_insurance,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.issueForm.total_insurance = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "意外险保险公司返胜辉" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.accident_rebate_shenghui,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.issueForm.accident_rebate_shenghui = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "保险公司返胜辉金额" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.company_rebate_shenghui,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.issueForm.company_rebate_shenghui = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "（贴点费用）返点差异" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.rebate_diff,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.issueForm.rebate_diff = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "贴点" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.subsidy,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.issueForm.subsidy = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "赠送项目" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.gift_item,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.issueForm.gift_item = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "赠送成本" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.gift_cost,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.issueForm.gift_cost = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "备注" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "input-wid",
                      modelValue: _ctx.issueForm.remark,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.issueForm.remark = $event)),
                      type: "textarea"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "战败原因",
      modelValue: _ctx.defeatForm.dialog_show,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.defeatForm.dialog_show = $event)),
      center: "",
      width: 500
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_28, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.defeatSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.defeatForm.dialog_show = false))
          }, {
            default: _withCtx(() => [
              _hoisted_30
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.defeatForm,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "车牌" }, {
              default: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.defeatForm.car_code), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "到期类别" }, {
              default: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.defeatForm.expire_text), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "战败原因",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.defeatForm.reason,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.defeatForm.reason = $event)),
                  type: "textarea",
                  rows: 4,
                  placeholder: "请输入战败原因总结"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "报价",
      modelValue: _ctx.quoteForm.dialog_show,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.quoteForm.dialog_show = $event)),
      center: "",
      width: 500
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_31, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.quoteSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_32
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.quoteForm.dialog_show = false))
          }, {
            default: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.quoteForm,
          "label-width": "90px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "车牌" }, {
              default: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.quoteForm.car_code), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "报价人",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "input-wid",
                  modelValue: _ctx.quoteForm.quoter,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.quoteForm.quoter = $event)),
                  placeholder: "请选择",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.issueForm.staff_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.username,
                        value: item.name,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "报价内容",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "input-wid",
                  modelValue: _ctx.quoteForm.content,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.quoteForm.content = $event)),
                  type: "textarea",
                  rows: 4,
                  placeholder: "请输入报价内容"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "跟进记录",
      modelValue: _ctx.followForm.dialog_show,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.followForm.dialog_show = $event)),
      center: "",
      width: 500
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_34, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.followSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_35
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.followForm.dialog_show = false))
          }, {
            default: _withCtx(() => [
              _hoisted_36
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.followForm,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "车牌" }, {
              default: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.followForm.car_code), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "跟进人",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "input-wid",
                  modelValue: _ctx.followForm.follower,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.followForm.follower = $event)),
                  placeholder: "请选择",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.issueForm.staff_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.username,
                        value: item.name,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "跟进内容",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.followForm.content,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.followForm.content = $event)),
                  type: "textarea",
                  rows: 4,
                  placeholder: "请输入跟进内容"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}